import {
  // Search
  SEARCH_TAG,
  SEARCH_TAG_FAILURE,
  SEARCH_TAG_SUCCESS,
  // Tags
  UPDATE_FEED_TAGS,
  RESET_FEED_TAGS,
  // Delete
  DELETE_TAG,
  DELETE_TAG_SUCCESS,
  DELETE_TAG_FAILURE,
  // Reactions
  ADD_REACTION,
  ADD_REACTION_SUCCESS,
  ADD_REACTION_FAILURE,
  // Reactions
  FETCH_REACTIONS,
  FETCH_REACTIONS_SUCCESS,
  FETCH_REACTIONS_FAILURE,
  // Reaction Modal
  TOGGLE_REACTION_MODAL,
  // Acknowledge
  ACKNOWLEDGE_FEED,
  ACKNOWLEDGE_FEED_SUCCESS,
  ACKNOWLEDGE_FEED_FAILURE,
  // Report Modal
  TOGGLE_REPORT_MODAL,
  // Stats
  FETCH_STATS,
  FETCH_STATS_SUCCESS,
  FETCH_STATS_FAILURE,
  // Engage Report
  FETCH_ENGAGE_REPORT,
  FETCH_ENGAGE_REPORT_SUCCESS,
  FETCH_ENGAGE_REPORT_FAILURE,
  // Engage Report Filters
  ENGAGE_REPORT_FILTERS,
  // Option Modal
  TOGGLE_OPTION_MODAL,
  // Kudos Leaderboard
  GET_KUDOS_LEADERBOARD,
  GET_KUDOS_LEADERBOARD_SUCCESS,
  GET_KUDOS_LEADERBOARD_FAILURE,
  KUDOS_LEADERBOARD_FILTERS,
  // Pin Feed
  PIN_FEED,
  PIN_FEED_SUCCESS,
  PIN_FEED_FAILURE,
  // Export Acknowledged Feeds
  EXPORT_ACKNOWLEDGED_FEEDS,
  EXPORT_ACKNOWLEDGED_FEEDS_SUCCESS,
  EXPORT_ACKNOWLEDGED_FEEDS_FAILURE,
} from "./constants";

export const searchTag = (payload) => ({
  type: SEARCH_TAG,
  payload,
});
export const searchTagSuccess = (payload) => ({
  type: SEARCH_TAG_SUCCESS,
  payload,
});
export const searchTagFailure = (payload) => ({
  type: SEARCH_TAG_FAILURE,
  payload,
});
export const resetFeedTags = () => ({
  type: RESET_FEED_TAGS,
});
export const updateFeedTags = (payload) => ({
  type: UPDATE_FEED_TAGS,
  payload,
});
export const deleteTag = (payload, onDelete) => ({
  type: DELETE_TAG,
  payload,
  onDelete,
});
export const deleteTagSuccess = (payload) => ({
  type: DELETE_TAG_SUCCESS,
  payload,
});
export const deleteTagFailure = (payload) => ({
  type: DELETE_TAG_FAILURE,
  payload,
});

// Reactions
export const addReaction = (payload, onSuccess) => ({
  type: ADD_REACTION,
  payload,
  onSuccess,
});
export const addReactionSuccess = (payload) => ({
  type: ADD_REACTION_SUCCESS,
  payload,
});
export const addReactionFailure = (payload) => ({
  type: ADD_REACTION_FAILURE,
  payload,
});
export const fetchReactions = (payload) => ({
  type: FETCH_REACTIONS,
  payload,
});
export const fetchReactionsSuccess = (payload) => ({
  type: FETCH_REACTIONS_SUCCESS,
  payload,
});
export const fetchReactionsFailure = (payload) => ({
  type: FETCH_REACTIONS_FAILURE,
  payload,
});
export const toggleReactionModal = (payload) => ({
  type: TOGGLE_REACTION_MODAL,
  payload,
});
export const acknowledgeFeed = (payload, onSuccess) => ({
  type: ACKNOWLEDGE_FEED,
  payload,
  onSuccess,
});
export const acknowledgeFeedSuccess = (payload) => ({
  type: ACKNOWLEDGE_FEED_SUCCESS,
  payload,
});
export const acknowledgeFeedFailure = (payload) => ({
  type: ACKNOWLEDGE_FEED_FAILURE,
  payload,
});
export const toggleReportModal = (payload) => ({
  type: TOGGLE_REPORT_MODAL,
  payload,
});
// Stats
export const fetchStats = (payload) => ({
  type: FETCH_STATS,
  payload,
});
export const fetchStatsSuccess = (payload) => ({
  type: FETCH_STATS_SUCCESS,
  payload,
});
export const fetchStatsFailure = (payload) => ({
  type: FETCH_STATS_FAILURE,
  payload,
});
// Engage Report
export const fetchEngageReport = (payload) => ({
  type: FETCH_ENGAGE_REPORT,
  payload,
});
export const fetchEngageReportSuccess = (payload) => ({
  type: FETCH_ENGAGE_REPORT_SUCCESS,
  payload,
});
export const fetchEngageReportFailure = (payload) => ({
  type: FETCH_ENGAGE_REPORT_FAILURE,
  payload,
});
// Engage Report Filters
export const setEngageReportFilters = (payload) => ({
  type: ENGAGE_REPORT_FILTERS,
  payload,
});
// Option Modal
export const toggleOptionModal = (payload) => ({
  type: TOGGLE_OPTION_MODAL,
  payload,
});
// Kudos Leaderboard
export const getKudosLeaderboard = (payload) => ({
  type: GET_KUDOS_LEADERBOARD,
  payload,
});
export const getKudosLeaderboardSuccess = (payload) => ({
  type: GET_KUDOS_LEADERBOARD_SUCCESS,
  payload,
});
export const getKudosLeaderboardFailure = (payload) => ({
  type: GET_KUDOS_LEADERBOARD_FAILURE,
  payload,
});
// Kudos Leaderboard Filters
export const setKudosLeaderboardFilters = (payload) => ({
  type: KUDOS_LEADERBOARD_FILTERS,
  payload,
});

// Pin Feed
export const pinFeed = (payload, onSuccess) => ({
  type: PIN_FEED,
  payload,
  onSuccess,
});
export const pinFeedSuccess = (payload) => ({
  type: PIN_FEED_SUCCESS,
  payload,
});
export const pinFeedFailure = (payload) => ({
  type: PIN_FEED_FAILURE,
  payload,
});

// Export Acknowledged Feeds
export const exportAcknowledgedFeeds = (payload) => ({
  type: EXPORT_ACKNOWLEDGED_FEEDS,
  payload,
});
export const exportAcknowledgedFeedsSuccess = (payload) => ({
  type: EXPORT_ACKNOWLEDGED_FEEDS_SUCCESS,
  payload,
});
export const exportAcknowledgedFeedsFailure = (payload) => ({
  type: EXPORT_ACKNOWLEDGED_FEEDS_FAILURE,
  payload,
});
